var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrmRisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M514.2 560l75.5 39.7-14.4-84.1 61.1-59.6-84.4-12.2-37.8-76.5-37.8 76.5L392 456l61.1 59.6-14.4 84.1 75.5-39.7zM347.4 725.4l31.9-185.8-135-131.6 186.5-27 83.4-169 83.4 169 186.5 27.1-135 131.6L681 725.5l-166.8-87.7-166.8 87.6zm-71.9-53.8c47.1 96.7 126.6 163.6 240.6 201.8C625 849 705.5 782.5 759.6 671.6c54.8-112.4 82-248.6 81.4-408.8L512.9 152.2 189.3 262.1c.4 6.4 1 13.2 1.6 20.5 2.9 36.1 7.1 74.8 12.7 114.3 15.7 111.7 39.4 207.9 71.9 274.7zm245.5 271l-8.7 1.7-8.5-2.7c-135.9-43.2-233.3-123.5-290.1-240-36.4-74.7-61.6-177-78.3-295.2-5.8-40.9-10.1-80.9-13.1-118.3-1.1-13.1-1.9-25-2.5-35.4-.4-6.3-.6-10.8-.7-13.2l-1.1-25.7L512.8 79.6l396.1 133.6.5 24.1c3.8 181-25.4 335.8-88.1 464.4C756.7 834.4 655.8 915.5 521 942.6z"
  })));
}

export default SvgCrmRisk;